require('./aggregatorLoanAndMortgageBox.scss');

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// @components
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { AggregatorGenericBox } from '../aggregatorGenericBox/aggregatorGenericBox';
import { AggregatorLoanAndMortgageDetails } from 'components/aggregator/aggregatorDetails/aggregatorLoanAndMortgageDetails/aggregatorLoanAndMortgageDetails';

// @constants
import { LOAN, MORTGAGE } from 'constants/aggregator/subtypes';

// @helpers
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

const { FormattedText } = require('core/i18n').i18n;

class AggregatorLoanAndMortgageBox extends React.PureComponent {
  renderSubtype = subtype => {
    const { key, loanMortgages, isTinkAggregator } = this.props;

    const balanceBySubtype = loanMortgages.getIn(['subproducts', subtype, 'balance']);
    const productsBySubtype = loanMortgages.getIn(['subproducts', subtype, 'items'], { size: 0 });
    const numberOfProducts = productsBySubtype.size;
    const expanded = productsBySubtype.size == 1;

    return (
      <AggregatorGenericBox
        expanded={expanded}
        header={this.renderHeader(subtype, balanceBySubtype, numberOfProducts, key)}
        body={this.renderBody(productsBySubtype, isTinkAggregator)}
      />
    );
  };

  renderHeader = (subtype, balance, numberOfProducts, key) => {
    const plainAmountObject = balance && getPlainAmountObject(balance);

    const iconMap = {
      [LOAN]: 'rebrand-loans',
      [MORTGAGE]: 'rebrand-mortgages',
    };

    return (
      <div className="aggregator-loan-mortgage-box-header" id={subtype} key={key}>
        <section>
          <div className="clearfix">
            <div className="pull-left">
              <i className={`aggregator-loan-mortgage-box-header__icon icon ${iconMap[subtype]}`} />
              <span className="aggregator-loan-mortgage-box-header__text">
                <FormattedText value={`aggregatorLoansMortgages-${subtype}`} />
              </span>
              <span className="aggregator-loan-mortgage-box-header__number">
                ({numberOfProducts})
              </span>
            </div>
            <div className="pull-right">
              <div>
                <FormattedText
                  className="aggregator-loan-mortgage-box-header__balance-title"
                  value="accordionAccount-balance"
                />
              </div>
              {!!plainAmountObject && (
                <div>
                  <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    className="aggregator-loan-mortgage-box-header__balance-value"
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  };

  renderBody = (products, isTinkAggregator) => {
    return (
      <div className="aggregator-loan-mortgage-box-body">
        <AggregatorLoanAndMortgageDetails products={products} isTinkAggregator={isTinkAggregator} />
      </div>
    );
  };

  render() {
    return (
      <Fragment>
        {this.renderSubtype(LOAN)}
        {this.renderSubtype(MORTGAGE)}
      </Fragment>
    );
  }
}

AggregatorLoanAndMortgageBox.propTypes = {
  // each product must be {
  //
  //
  //}
  key: PropTypes.string,
  loanMortgages: PropTypes.object,
  isTinkAggregator: PropTypes.bool,
};

export { AggregatorLoanAndMortgageBox };
